import { Button, Group, Modal, ModalProps, Stack, Text } from 'ui';

interface UnfollowConfirmationModalProps extends ModalProps {
  handleModalActions: (confirmDeletion: boolean) => void;
  causeName?: string;
  isUpdatingCauseSelections: boolean;
}

const UnfollowConfirmationModal = ({
  handleModalActions,
  causeName,
  isUpdatingCauseSelections,
  ...modalProps
}: UnfollowConfirmationModalProps) => (
  <Modal title="Unfollow" centered {...modalProps}>
    <Stack gap="md">
      <Text fw={600} fz="md">
        Are you sure you want to unfollow {causeName || 'this cause'}?
      </Text>
      <Text c="gray.6" fz="sm">
        If you unfollow {causeName || 'this cause'}, they&apos;ll be removed from your homepage,
        making them harder to find later.
      </Text>
    </Stack>
    <Group mt="xl" w="100%">
      <Button variant="outline" onClick={() => handleModalActions(false)} style={{ flex: 1 }}>
        Cancel
      </Button>
      <Button
        color="cerise.7"
        onClick={() => handleModalActions(true)}
        loading={isUpdatingCauseSelections}
        style={{ flex: 1 }}
      >
        Unfollow
      </Button>
    </Group>
  </Modal>
);

export { UnfollowConfirmationModal };
